import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, Check, X, Shield, HelpCircle, ChevronDown, ChevronUp, ArrowRight, Lock, RefreshCw, Download } from 'lucide-react';
export function BonusSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Y si mi pareja no quiere?',
    a: "Empieza tú. El Kit Noche Cero tiene un guion de 45 segundos para proponer sin presión. La respuesta más común es: '¿Solo 5 minutos? Ok.'"
  }, {
    q: '¿Cuánto tiempo toma?',
    a: '10–20 minutos por noche. 7 noches. El Ritual 7x7 son 7 minutos por semana después.'
  }, {
    q: '¿Qué pasa si hoy es Rojo?',
    a: 'Perfecto. Los Bonos #1 y #3 tienen Plan B específico para eso. Rojo no es fracaso. Es información.'
  }, {
    q: '¿Es contenido explícito?',
    a: 'No. Es romántico, sutil y elegante. Besos, abrazos, caricias y cercanía real. Sin vulgaridad.'
  }, {
    q: '¿Cómo recibo todo?',
    a: 'Acceso inmediato después del pago. Descarga directa. Sin esperar. Sin apps extras.'
  }, {
    q: '¿Hay suscripción?',
    a: 'No. Pago único de $19.97. Una vez. Para siempre.'
  }];
  return <div className="w-full overflow-hidden" data-id="element-31">
      {/* 1. INTRO HOOK */}
      <section className="py-20 bg-cream px-6 text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-33">
          <div className="flex justify-center mb-6" data-id="element-34">
            <div className="bg-wine/10 p-4 rounded-full" data-id="element-35">
              <Gift className="w-8 h-8 text-wine" data-id="element-36" />
            </div>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-wine-dark mb-6" data-id="element-37">
            Pero eso no es todo lo que recibes hoy.
          </h2>
          <p className="text-xl text-charcoal/80 leading-relaxed mb-4" data-id="element-38">
            Porque junto con la guía… incluyo 3 bonos que resuelven los 3
            momentos exactos donde la mayoría abandona:
          </p>
          <p className="text-xl text-wine font-bold leading-relaxed" data-id="element-39">
            Todo esto normalmente costaría $188… pero hoy lo tienes por solo
            $19.97.
          </p>
        </motion.div>
      </section>

      {/* 2. THREE BONUS CARDS */}

      {/* BONO #1 */}
      <section className="py-20 bg-white px-6 border-t border-cream-dark" data-id="element-40">
        <div className="container mx-auto max-w-5xl" data-id="element-41">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-42">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative group" data-id="element-43">
              <div className="absolute inset-0 bg-wine/5 rounded-xl transform rotate-3 transition-transform group-hover:rotate-6" data-id="element-44"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fLBWxNP84s2NN8ykfKp3JR/BonoUno.png" alt="El Kit Noche Cero" className="relative rounded-xl shadow-2xl w-full max-w-md mx-auto transform -rotate-2 transition-transform group-hover:rotate-0" data-id="element-45" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-46">
              <div className="flex items-center gap-4 mb-4" data-id="element-47">
                <span className="bg-wine text-cream px-3 py-1 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-48">
                  <Gift className="w-3 h-3" data-id="element-49" /> BONO #1
                </span>
                <div className="text-sm font-medium" data-id="element-50">
                  <span className="text-red-500 line-through mr-2" data-id="element-51">$47</span>
                  <span className="text-green-600 font-bold" data-id="element-52">GRATIS</span>
                </div>
              </div>

              <h3 className="text-3xl font-serif font-bold text-wine-dark mb-2" data-id="element-53">
                El Kit "Noche Cero"
              </h3>
              <p className="text-amber-dark font-medium text-lg mb-6" data-id="element-54">
                Setup en 10 minutos para que HOY sea fácil
              </p>

              <p className="text-charcoal/80 mb-8 italic border-l-4 border-amber/30 pl-4" data-id="element-55">
                "La Noche 1 nunca pasa porque nadie sabe cómo empezarla sin que
                se sienta raro. Este kit lo resuelve en 10 minutos exactos:"
              </p>

              <ul className="space-y-3 mb-8" data-id="element-56">
                {['Checklist de setup físico + emocional', 'El Pacto de 3 Reglas (nadie se siente presionado/a)', 'Tarjeta Semáforo (móvil + imprimible)', 'Guion de 45 segundos para iniciar (3 versiones)', 'Micro‑inicio de 2 pasos (mano + abrazo sin expectativas)', 'Plan B si hoy es Rojo (sin drama, sin pelea)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-57">
                    <Check className="w-5 h-5 text-wine mt-0.5 flex-shrink-0" data-id="element-58" />
                    <span data-id="element-59">{item}</span>
                  </li>)}
              </ul>

              <p className="font-serif italic text-wine text-lg" data-id="element-60">
                "Con este bono, la Noche 1 no queda en 'ya mañana'. Queda en
                HOY."
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* BONO #2 */}
      <section className="py-20 bg-cream px-6 border-t border-cream-dark" data-id="element-61">
        <div className="container mx-auto max-w-5xl" data-id="element-62">
          <div className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse" data-id="element-63">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="md:order-2 relative group" data-id="element-64">
              <div className="absolute inset-0 bg-wine/5 rounded-xl transform -rotate-3 transition-transform group-hover:-rotate-6" data-id="element-65"></div>
              <img src="https://cdn.magicpatterns.com/uploads/iJTdTz1sveSJ5h97EmtizS/BonoDos.png" alt="El Banco de Frases Anti-Pena" className="relative rounded-xl shadow-2xl w-full max-w-md mx-auto transform rotate-2 transition-transform group-hover:rotate-0" data-id="element-66" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="md:order-1" data-id="element-67">
              <div className="flex items-center gap-4 mb-4" data-id="element-68">
                <span className="bg-wine text-cream px-3 py-1 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-69">
                  <Gift className="w-3 h-3" data-id="element-70" /> BONO #2
                </span>
                <div className="text-sm font-medium" data-id="element-71">
                  <span className="text-red-500 line-through mr-2" data-id="element-72">$47</span>
                  <span className="text-green-600 font-bold" data-id="element-73">GRATIS</span>
                </div>
              </div>

              <h3 className="text-3xl font-serif font-bold text-wine-dark mb-2" data-id="element-74">
                El Banco de Frases Anti‑Pena
              </h3>
              <p className="text-amber-dark font-medium text-lg mb-6" data-id="element-75">
                50 inicios sutiles que no dan cringe
              </p>

              <p className="text-charcoal/80 mb-8 italic border-l-4 border-amber/30 pl-4" data-id="element-76">
                "Quieres acercarte. Tu cabeza se congela. ¿Qué digo? ¿Cómo
                inicio sin sonar intenso/a? ¿Y si suena actuado? Y no dices
                nada. Y el momento pasa. Este bono existe para ese momento
                exacto."
              </p>

              <ul className="space-y-3 mb-8" data-id="element-77">
                {['50 frases organizadas por situación (7 categorías)', 'Selector rápido por situación (1 minuto)', '12 mensajes WhatsApp listos (copy/paste)', 'Versión móvil para screenshot', 'Mini práctica de 3 días para perder la pena'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-78">
                    <Check className="w-5 h-5 text-wine mt-0.5 flex-shrink-0" data-id="element-79" />
                    <span data-id="element-80">{item}</span>
                  </li>)}
              </ul>

              <p className="font-serif italic text-wine text-lg" data-id="element-81">
                "Si tu mayor bloqueo es no saber qué decir… este bono te lo
                resuelve en 2 minutos."
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* BONO #3 */}
      <section className="py-20 bg-white px-6 border-t border-cream-dark" data-id="element-82">
        <div className="container mx-auto max-w-5xl" data-id="element-83">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-84">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative group" data-id="element-85">
              <div className="absolute inset-0 bg-wine/5 rounded-xl transform rotate-3 transition-transform group-hover:rotate-6" data-id="element-86"></div>
              <img src="https://cdn.magicpatterns.com/uploads/iwXZia69MHcZPnveqoXake/BonoTres.png" alt="El Ritual 7x7" className="relative rounded-xl shadow-2xl w-full max-w-md mx-auto transform -rotate-2 transition-transform group-hover:rotate-0" data-id="element-87" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-88">
              <div className="flex items-center gap-4 mb-4" data-id="element-89">
                <span className="bg-wine text-cream px-3 py-1 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-90">
                  <Gift className="w-3 h-3" data-id="element-91" /> BONO #3
                </span>
                <div className="text-sm font-medium" data-id="element-92">
                  <span className="text-red-500 line-through mr-2" data-id="element-93">$47</span>
                  <span className="text-green-600 font-bold" data-id="element-94">GRATIS</span>
                </div>
              </div>

              <h3 className="text-3xl font-serif font-bold text-wine-dark mb-2" data-id="element-95">
                El Ritual 7×7
              </h3>
              <p className="text-amber-dark font-medium text-lg mb-6" data-id="element-96">
                Para no volver a cero después de la semana 1
              </p>

              <p className="text-charcoal/80 mb-8 italic border-l-4 border-amber/30 pl-4" data-id="element-97">
                "La mayoría mejora una semana. Hay besos. Hay abrazo. Hay
                cercanía. Y luego… vuelve la rutina. El cansancio. El trabajo. Y
                vuelven a cero. No porque no quieran. Sino porque sin un ritual
                que se repita… todo se evapora. El Ritual 7×7 cierra ese hoyo
                para siempre."
              </p>

              <ul className="space-y-3 mb-8" data-id="element-98">
                {['Ritual minuto a minuto (7 min exactos + guion)', 'Las 7 preguntas semanales (una por semana, sin presión)', "Plantilla 'Agenda de Cercanía' (día/hora fijo)", 'Contacto según color (verde/amarillo/rojo explicado)', 'Versión mini 3 minutos (para noches difíciles)', 'Tracker de 4 semanas (imprimible + móvil)', 'Frases de reparación si la semana estuvo difícil'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-99">
                    <Check className="w-5 h-5 text-wine mt-0.5 flex-shrink-0" data-id="element-100" />
                    <span data-id="element-101">{item}</span>
                  </li>)}
              </ul>

              <p className="font-serif italic text-wine text-lg" data-id="element-102">
                "Este bono convierte una semana buena en un sistema que dura
                meses."
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 3. VALUE TABLE SECTION */}
      <section className="py-20 bg-wine-dark text-cream px-6" data-id="element-103">
        <div className="container mx-auto max-w-3xl" data-id="element-104">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-amber text-center mb-12" data-id="element-105">
            Todo lo que recibes hoy
          </motion.h2>

          <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-sm mb-12" data-id="element-106">
            <div className="grid grid-cols-3 bg-white/10 p-4 font-bold text-amber-light border-b border-white/10" data-id="element-107">
              <div className="col-span-2" data-id="element-108">Lo que llevas</div>
              <div className="text-right" data-id="element-109">Valor real</div>
            </div>

            {[{
            name: 'Guía 7 Noches Para Volver a Tocarnos',
            price: '$47'
          }, {
            name: 'BONO #1: El Kit Noche Cero',
            price: '$47'
          }, {
            name: 'BONO #2: Banco de Frases Anti‑Pena',
            price: '$47'
          }, {
            name: 'BONO #3: El Ritual 7×7',
            price: '$47'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-3 p-4 border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-110">
                <div className="col-span-2 flex items-center gap-2" data-id="element-111">
                  <Check className="w-4 h-4 text-amber flex-shrink-0" data-id="element-112" />
                  <span data-id="element-113">{item.name}</span>
                </div>
                <div className="text-right text-cream/60 line-through" data-id="element-114">
                  {item.price}
                </div>
              </motion.div>)}

            <div className="grid grid-cols-3 p-4 bg-white/5 border-b border-white/10" data-id="element-115">
              <div className="col-span-2 font-bold text-cream/80" data-id="element-116">
                Valor total real
              </div>
              <div className="text-right font-bold text-cream/60 line-through" data-id="element-117">
                $188
              </div>
            </div>

            <div className="grid grid-cols-3 p-6 bg-amber/20" data-id="element-118">
              <div className="col-span-2 font-bold text-xl text-amber-light flex flex-col justify-center" data-id="element-119">
                <span data-id="element-120">Lo que pagas hoy</span>
                <span className="text-sm font-normal opacity-80" data-id="element-121">
                  (oferta por tiempo limitado)
                </span>
              </div>
              <div className="text-right font-bold text-3xl text-amber flex items-center justify-end" data-id="element-122">
                $19.97
              </div>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center space-y-4 max-w-2xl mx-auto" data-id="element-123">
            <p className="font-serif italic text-xl text-cream/90" data-id="element-124">
              "Este precio no refleja el valor del contenido. Refleja que quiero
              que digas que sí sin pensarlo dos veces."
            </p>
            <p className="text-cream/70" data-id="element-125">
              Un café cuesta más que esto. Una cita promedio cuesta $30–80 y no
              garantiza conexión. Esto cuesta $19.97… y te deja un sistema
              completo que repiten semana tras semana.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 4. GUARANTEE SECTION */}
      <section className="py-20 bg-cream px-6 text-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-127">
          <div className="flex justify-center mb-6" data-id="element-128">
            <Shield className="w-16 h-16 text-wine" data-id="element-129" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wine-dark mb-6" data-id="element-130">
            Garantía total de 7 días
          </h2>
          <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-131">
            Prueba los 7 días completos. Si no sientes que la vergüenza
            disminuyó y la cercanía mejoró, te devuelvo el 100% de tu dinero sin
            preguntas.
          </p>
        </motion.div>
      </section>

      {/* 5. FOR WHOM SECTION */}
      <section className="py-20 bg-white px-6 border-y border-cream-dark" data-id="element-132">
        <div className="container mx-auto max-w-5xl" data-id="element-133">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-134">
            {/* NO */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-red-50/50 p-8 rounded-2xl border border-red-100" data-id="element-135">
              <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-136">
                <X className="w-6 h-6" data-id="element-137" /> Para quién NO es esto
              </h3>
              <ul className="space-y-4" data-id="element-138">
                {['Si buscas contenido explícito o vulgar: no es esto.', 'Si hay violencia o coerción en la relación: busca apoyo profesional.', 'Si están en ruptura activa: esto no aplica.', 'Si quieres resultados sin intentar nada: tampoco.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/80" data-id="element-139">
                    <X className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-140" />
                    <span data-id="element-141">{item}</span>
                  </li>)}
              </ul>
            </motion.div>

            {/* SI */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-green-50/50 p-8 rounded-2xl border border-green-100" data-id="element-142">
              <h3 className="text-xl font-bold text-green-800 mb-6 flex items-center gap-2" data-id="element-143">
                <Check className="w-6 h-6" data-id="element-144" /> Para quién SÍ es esto
              </h3>
              <ul className="space-y-4" data-id="element-145">
                {['Para la pareja que se quiere pero se traba.', "Para quien tiene pena de iniciar y miedo al 'no'.", 'Para quien quiere romance real, no actuación.', 'Para quien está listo/a para intentarlo chiquito… hoy.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-green-900/80" data-id="element-146">
                    <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-147" />
                    <span data-id="element-148">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 5.5 TESTIMONIALS SECTION */}
      <section className="py-20 bg-cream px-6 border-b border-cream-dark" data-id="element-149">
        <div className="container mx-auto max-w-6xl" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wine-dark text-center mb-12" data-id="element-151">
            Lo que dicen quienes ya lo intentaron
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-152">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-lg border border-cream-dark relative" data-id="element-153">
              <div className="text-amber text-4xl font-serif absolute top-4 left-6 opacity-50" data-id="element-154">
                "
              </div>
              <p className="text-charcoal/80 italic font-serif text-lg mb-6 relative z-10 pt-4" data-id="element-155">
                Pensé que ya nunca volveríamos a tener esa conexión… pero con
                los micro-inicios y el semáforo todo cambió en solo 4 noches. Ya
                no hay pena.
              </p>
              <div className="font-bold text-wine-dark" data-id="element-156">
                – Laura y Carlos, 32 años
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white p-8 rounded-2xl shadow-lg border border-cream-dark relative" data-id="element-157">
              <div className="text-amber text-4xl font-serif absolute top-4 left-6 opacity-50" data-id="element-158">
                "
              </div>
              <p className="text-charcoal/80 italic font-serif text-lg mb-6 relative z-10 pt-4" data-id="element-159">
                El Banco de Frases fue oro. Por fin puedo acercarme sin sentir
                que voy a decir algo equivocado.
              </p>
              <div className="font-bold text-wine-dark" data-id="element-160">– Mariana, 29 años</div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-8 rounded-2xl shadow-lg border border-cream-dark relative" data-id="element-161">
              <div className="text-amber text-4xl font-serif absolute top-4 left-6 opacity-50" data-id="element-162">
                "
              </div>
              <p className="text-charcoal/80 italic font-serif text-lg mb-6 relative z-10 pt-4" data-id="element-163">
                El Ritual 7×7 nos ayudó a que no volviera la rutina después de
                la primera semana. Ahora es parte de nuestra relación.
              </p>
              <div className="font-bold text-wine-dark" data-id="element-164">– José y Ana</div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 6. FAQ ACCORDION */}
      <section className="py-20 bg-white px-6" data-id="element-165">
        <div className="container mx-auto max-w-3xl" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wine-dark text-center mb-12" data-id="element-167">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-168">
            {faqs.map((faq, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="border border-cream-dark rounded-xl overflow-hidden" data-id="element-169">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-6 bg-cream/30 hover:bg-cream/50 transition-colors text-left" data-id="element-170">
                  <div className="flex items-center gap-4" data-id="element-171">
                    <HelpCircle className="w-5 h-5 text-wine flex-shrink-0" data-id="element-172" />
                    <span className="font-bold text-charcoal" data-id="element-173">{faq.q}</span>
                  </div>
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-charcoal/50" data-id="element-174" /> : <ChevronDown className="w-5 h-5 text-charcoal/50" data-id="element-175" />}
                </button>
                <AnimatePresence data-id="element-176">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-177">
                      <div className="p-6 pt-0 text-charcoal/80 leading-relaxed bg-cream/30 border-t border-cream-dark/50" data-id="element-178">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 7. FINAL CTA BLOCK */}
      <section id="pricing" className="py-24 bg-wine-dark text-cream px-6 text-center" data-id="element-179">
        <div className="container mx-auto max-w-4xl" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-181">
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-182">
              Una última cosa antes de que decidas:
            </h2>
            <p className="text-xl text-cream/80 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-183">
              No voy a decirte que esto se acaba. Solo te digo que cada noche
              que esperas… es otra noche que terminó en silencio. Y tú ya sabes
              cómo se siente eso.
            </p>

            <div className="mb-10" data-id="element-184">
              <div className="text-cream/50 text-xl line-through mb-2" data-id="element-185">
                $188 en valor real
              </div>
              <div className="text-6xl md:text-8xl font-bold text-amber tracking-tight mb-4" data-id="element-186">
                $19.97
              </div>
              <div className="text-cream/70 font-medium" data-id="element-187">
                Pago único. Acceso inmediato. Sin suscripción.
              </div>
            </div>

            <a href="https://omnilectura.com/cart/47962139132129:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', {
                content_name: '7 Noches Para Volver a Tocarnos',
                content_type: 'product',
                value: 19.97,
                currency: 'USD'
              });
            }
          }} data-id="element-188">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.98
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(212, 165, 116, 0)', '0 0 0 10px rgba(212, 165, 116, 0.1)', '0 0 0 20px rgba(212, 165, 116, 0)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="w-full md:w-auto px-10 py-6 bg-gradient-to-r from-amber to-amber-dark hover:from-amber-light hover:to-amber text-wine-dark font-bold text-xl md:text-2xl rounded-full shadow-xl transition-all duration-300 flex items-center justify-center mx-auto gap-3 group relative overflow-hidden mb-12" data-id="element-189">
                <span className="relative z-10" data-id="element-190">
                  Sí, quiero los 7 Noches + los 3 bonos por solo $19.97
                </span>
                <ArrowRight className="w-7 h-7 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-191" />
                <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 skew-x-12" data-id="element-192"></div>
              </motion.button>
            </a>

            <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm md:text-base text-cream/60" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <Lock className="w-5 h-5 text-amber" data-id="element-195" />
                <span data-id="element-196">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <RefreshCw className="w-5 h-5 text-amber" data-id="element-198" />
                <span data-id="element-199">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-200">
                <Download className="w-5 h-5 text-amber" data-id="element-201" />
                <span data-id="element-202">Acceso inmediato</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}